import { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./Incorporation.scss";
import Image from "react-bootstrap/Image";
import incorporationImg from "../../assets/images/incorporation-service.jpg";
import { NotificationManager } from "react-notifications";

import { getPageContent } from "../../api/apiRequest";  
import { useLangContext } from "../../context/languageContext";

const IncorporationService = () => {
  const {hostLanguage} = useLangContext();
  const [contentDetails,setContentDetails] = useState();

  // get page content
  const getAllPageContent = async() => {
    try
    {
      let apiRes = await  getPageContent(hostLanguage, "service_incorporation_page_data");
      let responseData = await apiRes.json();
      if(responseData.res)
      {
        setContentDetails(responseData.data);
      }
      else
      {
        NotificationManager.error(responseData.msg,'',2000);
      }
    }
    catch(error)
    {
      console.error(error);
    }
  }

  function splitDescription(html) {
    if (!html) return {};
    const sections = html.match(/<p><strong>[\s\S]*?(?=<p><strong>|$)/g);

    const result = {}
    if (sections) {
      sections.forEach((section, index) => {
        result[`description${index + 1}`] = section.trim();

      })
    }

    return result;
  }

  const separatedDescriptions = splitDescription(
    contentDetails?.service_incorporation_page_data?.description1
  );

  useEffect(()=>{
    getAllPageContent();
  },[hostLanguage]);

  return (
    <div className="MainbBody IncorporationService">
      <div className="PricelistBanner MapBanner">
        <Container>
          <Row>
            <Col sm={8}>
              <h3>{contentDetails?.service_incorporation_page_data?.title}</h3>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="PricelistBody">
        <Container>
          <div className="LocationGrid">
            <Row>
              <Col sm={12} md={6}>
                <div className="image">
                  <Image src={incorporationImg} alt="BoxImg" />
                </div>
              </Col>
              <Col sm={12} md={6}>
                <div 
                  className="description" 
                  dangerouslySetInnerHTML={{ __html: separatedDescriptions?.description1}} 
                />
              </Col>
            </Row>
          </div>

          <div className="LocationGrid">
            <Row>
              <Col sm={12}>
                <div 
                  className="description" 
                  dangerouslySetInnerHTML={{ __html: separatedDescriptions.description2}} 
                />
              </Col>
            </Row>
          </div>
          
          <div className="LocationGrid">
            <Row>
              <Col sm={12}>
                <div 
                  className="description" 
                  dangerouslySetInnerHTML={{ __html: separatedDescriptions.description3}} 
                />
              </Col>
            </Row>
          </div>
          
          <div className="LocationGrid">
            <Row>
              <Col sm={12} md={6}>
                <div 
                  className="description" 
                  dangerouslySetInnerHTML={{ __html: separatedDescriptions.description4}} 
                />
              </Col>
              <Col sm={12} md={6}>
                <div className="image">
                  <Image src={incorporationImg} alt="BoxImg" />
                </div>
              </Col>
            </Row>
          </div>
          
          <div className="LocationGrid">
            <Row>
              <Col sm={12}>
                <div 
                  className="description" 
                  dangerouslySetInnerHTML={{ __html: separatedDescriptions.description5}} 
                />
              </Col>
            </Row>
          </div>
          
          <div className="LocationGrid">
            <Row>
              <Col sm={12}>
                <div 
                  className="description" 
                  dangerouslySetInnerHTML={{ __html: separatedDescriptions.description6}} 
                />
              </Col>
            </Row>
          </div>
          
          <div className="LocationGrid">
            <Row>
              <Col sm={12}>
                <div 
                  className="description" 
                  dangerouslySetInnerHTML={{ __html: separatedDescriptions.description7}} 
                />
              </Col>
            </Row>
          </div>
          
          <div className="LocationGrid">
            <Row>
              <Col sm={12} md={6}>
                <div className="image">
                  <Image src={incorporationImg} alt="BoxImg" />
                </div>
              </Col>
              <Col sm={12} md={6}>
                <div 
                  className="description" 
                  dangerouslySetInnerHTML={{ __html: separatedDescriptions.description8}} 
                />
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default IncorporationService;
